import api from "./api";

const url = "compliance-subcategory";

const FindSubcategoryById = (id) =>
  api.get(`${url}/read-compliance-subcategory-by-id/${id}`);

export { FindSubcategoryById };
